module.exports = __webpack_public_path__ + "static/media/locationBlue.c0cfaf49.svg";